<template>
    <Button variant="outlined" size="sm" style="border-color: var(--p-primary-color);">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" class="h-6 w-6 flex-none">
            <circle cx="12" cy="12" r="11.5" stroke="var(--p-primary-color)"></circle>
            <path
                d="M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z"
                fill="var(--p-primary-color)" stroke="var(--p-primary-color)"></path>
        </svg>
        <span class="font-semibold">{{ t('headings.watch-the-video') }}</span>
    </Button>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';

const { t } = useI18n();
</script>